import type { CSSProperties, FC, ReactNode } from 'react'
import type { ChartAnimation } from '@/components/charts/chart-utils'

import { cn } from '@/lib/utils'

interface MiniBarsProps {
    values: Array<number>
    color: string
    mutedColor?: string
    height?: number
    animation?: ChartAnimation
    delay?: number
    className?: string
}

/** Compact column trend; the latest period is drawn in the full color. */
export const MiniBars: FC<MiniBarsProps> = ({
    values,
    color,
    mutedColor,
    height = 40,
    animation = 'inview',
    delay = 0,
    className
}): ReactNode => {
    const max = Math.max(...values) || 1
    const min = Math.min(...values)
    const floor = min * 0.82

    return (
        <div
            aria-hidden='true'
            className={cn('flex items-end gap-[3px]', animation === 'autoplay' && 'chart-autoplay', className)}
            data-chart={animation === 'manual' ? undefined : ''}
            data-inview={animation === 'autoplay' ? 'true' : undefined}
            style={{ height }}
        >
            {values.map((value, index) => (
                <span
                    key={index}
                    data-bar=''
                    className='chart-grow-y w-full rounded-t-[3px]'
                    style={{
                        height: `${Math.max(8, ((value - floor) / (max - floor || 1)) * 100)}%`,
                        backgroundColor: index === values.length - 1 ? color : (mutedColor ?? color),
                        opacity: index === values.length - 1 || mutedColor ? 1 : 0.28,
                        '--chart-delay': `${delay + index * 50}ms`
                    } as CSSProperties}
                />
            ))}
        </div>
    )
}
